import React, { useEffect, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useSelector } from 'react-redux';

const CategorizedTemplates = ({
    onSelectTemplate,
    type="email",
    disabled,
    defaultTemplate
}) => {
    const [open, setOpen] = useState(false);
    const [template, setTemplate] = useState('');
    const { email_categorized_templates, isReadingCategorizedTemplates, text_categorized_templates} = useSelector(state => state.template_category);
    const categorized_templates = type === "text" ? text_categorized_templates : email_categorized_templates
    const findTemplateName = (categorized_templates, templateId) => {
        for (const category of categorized_templates) {
            const found = category.templates?.data?.find(
                t => t.id === templateId
            );
            if (found) return found.name;
        }
        return null;
    };
    useEffect(() => {
        if (defaultTemplate && categorized_templates?.length > 0) {
            setTemplate(findTemplateName(categorized_templates, defaultTemplate));
        }
    }, [defaultTemplate, categorized_templates]);

    return (
        <Dropdown
            disabled={disabled}
            style={{
                float: 'left',
                marginTop: '0.2em'
            }}
            text={template ? <span className='Task__selected-template'>{template}</span> : 'Select Template'}
            icon={template ? 'times' : 'sort'}
            clearable
            value={template}
            onChange={() => {
                setTemplate('');
                onSelectTemplate(null);
                setOpen(false);
            }}
            onOpen={() => {setOpen(true)}}
            onClose={() => {setOpen(false)}}
            open={open}
            loading={isReadingCategorizedTemplates}
        >
            <Dropdown.Menu>
                {categorized_templates.filter(category => category.templates?.data?.length > 0).map(category => (
                    <Dropdown.Item>
                        <Dropdown simple className='Task__template-selector' fluid key={category.id} text={category.name}>
                            <Dropdown.Menu>
                                {(category.templates?.data || []).map(template => (
                                    <Dropdown.Item onClick={() => {
                                        onSelectTemplate(template.id);
                                        setOpen(false);
                                        setTemplate(template.name)
                                    }} key={template.id}>
                                        {template.name}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}



export default CategorizedTemplates
